__turbopack_context__.v({
  "highlight": "GridTicks-module__aoW5OW__highlight",
  "highlightX": "GridTicks-module__aoW5OW__highlightX",
  "highlightY": "GridTicks-module__aoW5OW__highlightY",
  "label": "GridTicks-module__aoW5OW__label",
  "tick": "GridTicks-module__aoW5OW__tick",
});
